// extracted by mini-css-extract-plugin
export default {"logo":"css-wQSAXLqi-A"};